import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ReactTable from 'react-table'
import { Button, Form, Modal, Popconfirm, Input, message, Tooltip } from 'antd'
import moment from 'moment'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/dobNoteActions'
import { filterCaseInsensitive } from '../../../util'

const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}

class DobNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null
    }
  }

  componentWillMount() {
    this.props.dobNotesRefresh({
      jobId: this.props.jobId
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row
    })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (this.state.currentId === 0) {
        this.props.createDobNote({
          jobId: this.props.jobId,
          description: values.description,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateDobNote({
          jobId: this.props.jobId,
          noteId: this.state.currentId,
          description: values.description,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteDobNote({
      jobId: this.props.jobId,
      noteId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  render() {
    const { contentData } = this.state
    const { getFieldDecorator } = this.props.form
    if (!this.props.dobNoteActions.dobNotes) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="DOB Notes"
          okText={contentData ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          maskClosable={false}
        >
          <Form layout="vertical">
            <FormItem label="Description">
              {getFieldDecorator('description', {
                rules: [
                  {
                    required: true,
                    message: 'Note description cannot be blank.'
                  }
                ],
                initialValue: contentData ? contentData.content : ''
              })(
                <TextArea
                  placeholder="Type in your code..."
                  rows={4}
                  initialvalue={contentData ? contentData.content : ''}
                />
              )}
            </FormItem>
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          DOB Notes
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Note
            </div>
          </div>
        </div>
        {this.props.dobNoteActions.dobNotes && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.dobNoteActions.dobNotes.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Note',
                    id: 'content',
                    accessor: d => d.content,
                    Cell: d => <Tooltip title={d.original.content}>{d.original.content}</Tooltip>
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.created_by_first_name} ${
                        d.original.created_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    width: 160
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name} ${
                        d.original.updated_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    width: 160
                  },
                  {
                    Header: 'Updated Date',
                    id: 'updated_date',
                    accessor: d => moment(d.updated_date).format('M/D/YYYY'),
                    width: 110
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ dobNoteActions }, ownProps) => ({ dobNoteActions })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

DobNotes.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(DobNotes)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/DobNotes.js